import classNames from "classnames";
import { PropTypes } from "base/react-libs";
import { Button, Icon } from "@evertrue/et-components";

const NavButton = ({ activeWhen, active, onSelect, icon, buttonProps, children }) => {
  return (
    <Button
      className={classNames(
        "nav-button",
        active === activeWhen ? "nav-button--active" : "nav-button--inactive journeys-nav-button"
      )}
      onClick={onSelect}
      {...buttonProps}
    >
      {icon && <Icon icon={icon} />}
      {children}
    </Button>
  );
};

NavButton.propTypes = {
  activeWhen: PropTypes.any,
  active: PropTypes.number,
  onSelect: PropTypes.func,
  icon: PropTypes.string,
  buttonProps: PropTypes.object,
  children: PropTypes.any,
};

export default NavButton;
